import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './Toast.css';

const Toast = ({ message, type, onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
        onClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  if (!visible) {
    return null;
  }

  const toastNode = (
    <div className={`toast-container ${type}`}>
      <div className="toast-message">{message}</div>
      <button className="toast-close-btn" onClick={() => { setVisible(false); onClose(); }}>
        &times;
      </button>
    </div>
  );

  if (typeof document !== 'undefined' && document.body) {
    return createPortal(toastNode, document.body);
  }

  return toastNode;
};

export default Toast;
